import { Form, FormProps } from "formik-tastic";

const FormContainer = ({
  className,
  formId,
  config,
}: {
  className?: string;
  formId?: string;
  config: FormProps;
}) => {
  return (
    <div id={formId} className={`form-container ${className}`}>
        <Form initialValues={config.initialValues} onSubmit={config.onSubmit} schema={config.schema} />
    </div>
  );
};

export default FormContainer;
